import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { AppService } from 'src/app/utils/services/app.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();

    @Output() toggleMenuSidebar: EventEmitter<any> = new EventEmitter<any>();
    public searchForm: FormGroup;

    envLabel: string;

    constructor(private router: Router, private store: Store<State>, private appService: AppService) {}

    ngOnInit() {
        this.searchForm = new FormGroup({
            search: new FormControl(null),
        });

        this.store
            .select(environmentSelector)
            .pipe(
                takeUntil(this.destroy$),
                tap((env) => (this.envLabel = env.label)),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    logout() {
        this.appService.logout();
    }
}
